import { Modal, Textarea, FileInput, Button, Text, Flex } from '@mantine/core';
import { IconPaperclip } from '@tabler/icons-react';

export const ActionModal = ({
  opened,
  onClose,
  actionType,
  comment,
  setComment,
  attachment,
  setAttachment,
  onSubmit,
  setError,
  error,
  crNumber,
}) => {
  const commentPlaceholder =
    actionType === 'Close'
      ? 'Enter your reason for closing the request here...'
      : 'Enter your reason for cancellation the request here...';

  return (
    <Modal
      size={'40%'}
      opened={opened}
      onClose={onClose}
      title={`${actionType} Request for CR Number: ${crNumber}`}
      styles={{
        title: {
          fontSize: '1.2rem',
          fontWeight: 700,
          color: '#1E88E5',
          textTransform: 'uppercase',
        },
      }}
    >
      <Textarea
        label='Comment'
        required={true}
        placeholder={commentPlaceholder}
        value={comment}
        onChange={(event) => {
          setComment(event.target.value);
        }}
        styles={{
          input: {
            display: 'inline-flex',
            justifyContent: 'center',
            border: '2px solid #ffc107',
          },
          label: { fontSize: '1.9vh', color: '#fff' },
          '::placeholder': {
            color: '#fff',
            opacity: 1,
          },
        }}
        mb='md'
        error={error ? 'Comment is required' : undefined}
      />
      {error && (
        <Text color='red' size='sm'>
          Comment is required.
        </Text>
      )}

      <FileInput
        label={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            Upload Attachment (Optional)
            <IconPaperclip size={16} style={{ marginLeft: 8 }} />
          </div>
        }
        placeholder='Choose file to upload'
        value={attachment}
        onChange={setAttachment}
      />
      <Flex justify='flex-end' mt='md'>
        <Button
          variant='gradient'
          radius='md'
          size='md'
          fullWidth
          onClick={onSubmit}
          style={{
            marginRight: '1rem',
            width: '200px',
          }}
          disabled={!comment.trim()}
        >
          Submit
        </Button>
      </Flex>
    </Modal>
  );
};
